export const IAddTipUseCaseType = Symbol('AddTipUseCase');
